'use client'

import React, { useState, useContext, useMemo, useEffect } from 'react'
import { useLocale } from 'next-intl'

import { Link } from '@/i18n/navigation'
import { useBreakpoint } from '@/hooks/useBreakpoint'
import { usePageContext } from '@/contexts/PageContext'

import HeaderContext from '@/components/molecules/Header/context/HeaderContext'
import { ButtonLabel } from '@/components/atoms/Typography'
import DropDown from '@/components/atoms/Dropdown'

import styles from './Languages.module.scss'

import { LOCALES } from '@/config/constants'

const getLocales = (items, currentLocale, isHomepage) => {
  return LOCALES.map((locale, index) => {
    if (locale === currentLocale) return null
    const item = items.find((item) => item.locale === locale)
    let href = '/'

    if (item) {
      href = isHomepage ? '/' : `/${item.slug}`
    }

    return {
      shortenedCode: locale,
      order: index,
      locale,
      href,
    }
  }).filter(Boolean)
}

const LanguagesList = ({ items }) =>
  items.map((link) => {
    const localeName = link.locale

    return (
      <li key={link.locale}>
        <Link
          translate='no'
          href={link.href}
          locale={link.locale}
        >
          <ButtonLabel>{localeName.toLocaleUpperCase()}</ButtonLabel>
        </Link>
      </li>
    )
  })

const Languages = () => {
  const locale = useLocale()
  const { isMobile } = useBreakpoint()
  const [mounted, setMounted] = useState(false)
  const { translationsItems } = useContext(HeaderContext)
  const { isHomepage } = usePageContext()

  const locales = useMemo(
    () => getLocales(translationsItems, locale, isHomepage),
    [translationsItems, locale, isHomepage]
  )

  const i18nUrls = useMemo(
    () =>
      locales.sort((a, b) => {
        const aFullLocale = locales.find(
          (loc) => loc.shortenedCode === a.locale
        )
        const bFullLocale = locales.find(
          (loc) => loc.shortenedCode === b.locale
        )
        return aFullLocale.order < bFullLocale.order ? -1 : 1
      }),
    [locales]
  )

  const hasMultipleLocales = LOCALES.length > 1

  useEffect(() => {
    setMounted(true)
  }, [])

  const showMobile = mounted && isMobile

  return (
    hasMultipleLocales && (
      <div className={styles.languages}>
        {showMobile ? (
          <ul className={styles.languagesList}>
            <LanguagesList items={i18nUrls} />
          </ul>
        ) : (
          <DropDown
            trigger={locale}
            triggerProps={{
              translate: 'no',
              style: { textTransform: 'uppercase', paddingInline: '0.75rem' },
            }}
          >
            <LanguagesList items={i18nUrls} />
          </DropDown>
        )}
      </div>
    )
  )
}

export default Languages
